import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import AdminFunctions from './AdminFunctions';
import apiFetch from '../services/ApiClient';
import '../layout/site.css';

export class UserDetails extends Component {
    static displayName = UserDetails.name;

    constructor(props) {
        super(props);

        this.state = {
            userId: null,
            active: true,
            firstName: '',
            lastName: '',
            officePhone: '',
            ext: '',
            homePhone: '',
            mobilePhone: '',
            email: '',
            // create-user result state
            success: null, // null=unknown/idle, true=success, false=failure
            error: null,
            inviteSuccess: null,   // null | true | false
            inviteMessage: null,   // string
            inviteWarning: null
        };
    }

    async componentDidMount() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
            return;
        }

        if (this.props.location.state !== undefined) {
            if (this.props.location.state.existingUser) {
                const userId = this.props.location.state.userId;
                this.setState({ userId: userId });
                await this.getUserDetails(userId);
            }
        } else {
            this.props.history.push('/admin/users');
        }
    }

    extractApiErrorMessage(data, fallback) {
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        if (data.message) return data.message;
        return fallback;
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>User Details</h3>
                        </Col>
                    </Row>

                    <Row className='row-20'>
                        <Col xs='6'>
                            <div className="form-check">
                                <Input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="active"
                                    checked={!!this.state.active}
                                    onChange={(e) => this.setState({ active: e.target.checked })}
                                />
                                <label className="form-check-label" htmlFor="active">
                                    Active
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name='firstName'
                                id='firstName'
                                placeholder='First Name'
                            />
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name='lastName'
                                id='lastName'
                                placeholder='Last Name'
                            />
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='4'>
                            <Input
                                type='tel'
                                value={this.state.officePhone}
                                onChange={(e) => this.setState({ officePhone: e.target.value })}
                                name='officePhone'
                                id='officePhone'
                                placeholder='Office Phone'
                            />
                        </Col>
                        <Col xs='2'>
                            <Input
                                type='text'
                                value={this.state.ext}
                                onChange={(e) => this.setState({ ext: e.target.value })}
                                name='ext'
                                id='ext'
                                placeholder='Ext.'
                            />
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='4'>
                            <Input
                                type='tel'
                                value={this.state.homePhone}
                                onChange={(e) => this.setState({ homePhone: e.target.value })}
                                name='homePhone'
                                id='homePhone'
                                placeholder='Home Phone'
                            />
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='4'>
                            <Input
                                type='tel'
                                value={this.state.mobilePhone}
                                onChange={(e) => this.setState({ mobilePhone: e.target.value })}
                                name='mobilePhone'
                                id='mobilePhone'
                                placeholder='Mobile Phone'
                            />
                        </Col>
                    </Row>

                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='email'
                                value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                name='email'
                                id='email'
                                placeholder='Email'
                            />
                        </Col>
                    </Row>

                    <Row className="row-20 align-items-center">
                        <Col xs="4" className="text-left">
                            <Button
                                color="primary"
                                onClick={() => this.props.history.push('/admin/users')}
                            >
                                Back to Users
                            </Button>
                        </Col>

                        <Col xs="4" className="text-center">
                            <Button
                                color="secondary"
                                onClick={() => this.resendInvite()}
                                disabled={!this.state.userId}
                            >
                                Resend Invitation
                            </Button>
                        </Col>

                        <Col xs="4" className="text-right">
                            <Button
                                color="primary"
                                onClick={() => this.handleSave()}
                            >
                                Save
                            </Button>
                        </Col>
                    </Row>

                    <Row className="row-20">
                        <Col>
                            {this.state.error && <Alert color="danger">{this.state.error}</Alert>}

                            {this.state.inviteWarning && <Alert color="warning">{this.state.inviteWarning}</Alert>}

                            {this.state.inviteMessage && (
                                <Alert color={this.state.inviteSuccess ? "success" : "danger"}>
                                    {this.state.inviteMessage}
                                </Alert>
                            )}

                            {this.state.success === true && !this.state.inviteMessage && !this.state.error && (
                                <Alert color="success">
                                    {this.state.userId ? "User updated successfully!" : "User added successfully!"}
                                </Alert>
                            )}
                        </Col>
                    </Row>                </Container>
            </div>
        );
    }

    async getUserDetails(userId) {
        this.setState({ error: null, inviteWarning: null, success: null });

        const r = await apiFetch(`/api/Admin/GetUserDetailsAsync?id=${encodeURIComponent(userId)}`, {
            method: 'GET'
        });

        if (r.status === 401) {
            this.props.history.push('/login');
            return;
        }
        if (r.status === 403) {
            this.props.history.push('/accessdenied');
            return;
        }
        if (!r.ok) {
            this.setState({ error: this.extractApiErrorMessage(r.data, 'Failed to load user details.') });
            return;
        }

        const data = r.data || {};
        this.setState({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            officePhone: data.officePhone || '',
            ext: data.ext || '',
            homePhone: data.homePhone || '',
            mobilePhone: data.mobilePhone || '',
            active: data.active === true
        });
    }

    async handleSave() {
        const dto = {
            id: this.state.userId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            officePhone: this.state.officePhone,
            ext: this.state.ext,
            homePhone: this.state.homePhone,
            mobilePhone: this.state.mobilePhone,
            active: this.state.active
        };

        if (this.state.userId) {
            await this.editUser(dto);
        } else {
            await this.createUser(dto);
        }
    }

    async editUser(dto) {
        this.setState({ success: null, error: null, inviteWarning: null });
        this.setState({ inviteSuccess: null, inviteMessage: null });

        const r = await apiFetch('api/Admin/EditUserAsync', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: { 'Content-Type': 'application/json' }
        });

        if (r.status === 401) {
            this.props.history.push('/login');
            return;
        }
        if (r.status === 403) {
            this.props.history.push('/accessdenied');
            return;
        }
        if (!r.ok) {
            this.setState({
                success: false,
                error: this.extractApiErrorMessage(r.data, 'User update failed.')
            });
            return;
        }

        // Existing behavior: backend returns boolean for edit (repo)
        const ok = r.data === true;
        this.setState({
            success: ok,
            error: ok ? null : 'User update failed.',
            inviteWarning: null
        });
    }

    async resendInvite() {
        this.setState({
            inviteSuccess: null,
            inviteMessage: null,
            error: null,
            inviteWarning: null
        });

        const email = (this.state.email || '').trim();
        if (!email) {
            this.setState({
                inviteSuccess: false,
                inviteMessage: "Cannot resend invite: user has no email."
            });
            return;
        }

        const r = await apiFetch('api/Admin/SendResetPasswordEmailAsync', {
            method: 'POST',
            body: JSON.stringify({ email }),
            headers: { 'Content-Type': 'application/json' }
        });

        if (r.status === 401) { this.props.history.push('/login'); return; }
        if (r.status === 403) { this.props.history.push('/accessdenied'); return; }

        // This endpoint returns bool (true/false)
        const ok = r.ok && r.data === true;

        this.setState({
            inviteSuccess: ok,
            inviteMessage: ok
                ? 'Invitation email sent.'
                : 'Invitation email could not be sent.'
        });
    }


    async createUser(dto) {
        this.setState({
            success: null,
            error: null,
            inviteWarning: null
        });
        this.setState({ inviteSuccess: null, inviteMessage: null });

        const r = await apiFetch('api/Admin/CreateUser', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: { 'Content-Type': 'application/json' }
        });

        if (r.status === 401) {
            this.props.history.push('/login');
            return;
        }
        if (r.status === 403) {
            this.props.history.push('/accessdenied');
            return;
        }
        if (!r.ok) {
            this.setState({
                success: false,
                error: this.extractApiErrorMessage(r.data, 'User creation failed.'),
                inviteWarning: null
            });
            return;
        }

        // result = { userCreated, inviteSent, code, message }
        const result = r.data || {};

        if (!result.userCreated) {
            this.setState({
                success: false,
                error: result.message || 'User creation failed.',
                inviteWarning: null
            });
            return;
        }

        if (!result.inviteSent) {
            this.setState({
                success: true,
                inviteWarning: result.message || 'User created, but invite email was not sent.',
                error: null
            });
            return;
        }

        this.setState({
            success: true,
            inviteWarning: null,
            error: null
        });
    }
}